import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { capitalizeFirstLetter } from '../../utils/index';
const TITLE_SUFFIX = '- Hookdeck';
const CLI_PREFIX = 'CLI';
const DEFAULT_TITLE = `Dashboard ${TITLE_SUFFIX}`;
interface UseTitleProps {
  title?: string;
  subtitle?: string;
  usePath?: boolean;
  capitalizeSubtitle?: boolean;
}
const setDocumentTitle = (title?: string) => {
  if (!title || typeof document === 'undefined') {
    document.title = DEFAULT_TITLE;
    return;
  }
  document.title = `${title} ${TITLE_SUFFIX}`;
};
const getTitle = (usePath: boolean, capitalizeSubtitle: boolean, pathname: string, title?: string, subtitle?: string) => {
  let newTitle: string;
  let prefix: string | undefined;
  const [, subpath1, subpath2, subpath3] = pathname.split('/');
  if (subpath1 === 'cli') {
    prefix = CLI_PREFIX;
  }
  if (usePath) {
    title = subpath1;
    subtitle = subpath2;
    if (title === 'cli') {
      title = subpath2;
      subtitle = subpath3;
    }
    if (title) {
      title = title.replace(/-/g, ' ').split(' ').map(word => capitalizeFirstLetter(word)).join(' ');
      if (subtitle) {
        subtitle = subtitle.replace(/-/g, ' ');
        if (capitalizeSubtitle) {
          subtitle = capitalizeFirstLetter(subtitle);
        }
      }
    }
  }
  newTitle = prefix ? `${prefix} ${title || ''}` : title || '';
  if (title && subtitle) {
    newTitle += ` - ${subtitle}`;
  }
  return newTitle;
};
const useTitle = t0 => {
  const $ = _c(7);
  const {
    title,
    subtitle,
    usePath: t1,
    capitalizeSubtitle: t2
  } = t0;
  const usePath = t1 === undefined ? false : t1;
  const capitalizeSubtitle = t2 === undefined ? false : t2;
  const {
    pathname
  } = useLocation();
  let t3;
  let t4;
  if ($[0] !== capitalizeSubtitle || $[1] !== pathname || $[2] !== subtitle || $[3] !== title || $[4] !== usePath) {
    t3 = () => {
      const newTitle = getTitle(usePath, capitalizeSubtitle, pathname, title, subtitle);
      setDocumentTitle(newTitle);
      return _temp;
    };
    t4 = [title, subtitle, usePath, pathname, capitalizeSubtitle];
    $[0] = capitalizeSubtitle;
    $[1] = pathname;
    $[2] = subtitle;
    $[3] = title;
    $[4] = usePath;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
};
export default useTitle;
function _temp() {
  document.title = DEFAULT_TITLE;
}